import { useMutation } from '@tanstack/react-query';
import { updateContactEmail } from '../../services/fn-api/User';

export const useUpdateContactEmail = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return updateContactEmail(data);
    },
  });
};
